
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import StartofYear from "./StarofYear";
import TeamofQuarterList from "./TeamofQuarterList";


function TeamofQuarterListMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <TeamofQuarterList/>
            </BasicCard>
        </>
    )
}
export default TeamofQuarterListMain;